import React from "react";
import BaseFormPage from "../../base/BaseFormPage";
import DMSPresenter from "../DMSPresenter";

class DemoRequestModal extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new DMSPresenter(this);
    this.state = {
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        contactNumber: "",
        employeeSize: "1–49",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.presenter.onChange(value, name);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.presenter.submit(this.state.formData);
  };

  render() {
    const { formData } = this.state;

    const features = [
      {
        title: "Streamline Processes",
        description: "Reduce paperwork and processing time to prioritize service delivery.",
      },
      {
        title: "Data-Driven Decisions",
        description: "Leverage real-time analytics to guide strategic and informed actions.",
      },
      {
        title: "Enhance Efficiency",
        description: "Automate tasks, minimize errors, and optimize team productivity.",
      },
    ];

    return (
      <div
        className="modal fade"
        id="demoRequestModal"
        tabIndex="-1"
        aria-labelledby="demoRequestModalLabel"
        aria-hidden="true"
        ref={this.modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content p-0 rounded-4 overflow-hidden">
            <div className="modal-body p-0">
              <div className="row g-0">
                {/* LEFT SIDE */}
                <div className="col-md-6 p-4" style={{ backgroundColor: "#e6ede6" }}>
                  <h3 className="fw-bold mb-4 mt-4">Transform your Operations</h3>
                  <ul className="list-unstyled">
                    {features.map((item, index) => (
                      <li key={index} className="mb-4 d-flex">
                        <img
                          src="/check-octagon-fill.svg"
                          alt="Check Icon"
                          width="24"
                          height="24"
                          className="me-3 mt-1"
                          style={{
                            filter:
                              "invert(36%) sepia(23%) saturate(706%) hue-rotate(71deg) brightness(92%) contrast(89%)",
                          }}
                        />
                        <div>
                          <strong>{item.title}</strong>
                          <p className="mb-0 text-muted">{item.description}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-6 p-4 bg-white mt-4">
                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-3">
                      <div className="col-6">
                        <label className="form-label">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Juan"
                          name="firstName"
                          value={formData.firstName}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Dela Cruz"
                          name="lastName"
                          value={formData.lastName}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Business Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="example@company.com"
                          name="email"
                          value={formData.email}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Company <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Business Company"
                          name="company"
                          value={formData.company}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="09123456789"
                          name="contactNumber"
                          value={formData.contactNumber}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          Employee Size <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="employeeSize"
                          value={formData.employeeSize}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="1–49">1–49</option>
                          <option value="50–99">50–99</option>
                          <option value="100–999">100–999</option>
                          <option value="1000–1999">1000–1999</option>
                          <option value="2000–3999">2000–3999</option>
                          <option value="4000+">4000+</option>
                        </select>
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn px-5 py-2 fw-semibold"
                        style={{ backgroundColor: "#020248", color: "#fff" }}
                      >
                        Schedule My Demo
                      </button>
                    </div>

                    <p className="text-muted mt-3 small text-center">
                      By completing and submitting the form, you will receive information, tips, and promotions from Tenth Corporation.
                    </p>
                  </form>
                </div>
              </div>
            </div>

            {/* CLOSE BUTTON */}
            <button
              type="button"
              className="btn-close position-absolute end-0 top-0 m-3"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
    );
  }
}

export default DemoRequestModal;
